import React, { useState } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { SecondaryButton, LicensePlateTextField, TextLarge, PrimaryButton } from '@hz-design-system/web-ui';

import { trackGAEvent } from '../../../utils/gaTracking';

import Classes from './SellBlock.scss';

type TSellBlockProps = {
  withLicensePlateField: boolean;
};

const SellBlock = ({ withLicensePlateField }: TSellBlockProps) => {
  const { t } = useI18nContext();
  const [licensePlate, setLicensePlate] = useState('');

  return (
    <>
      <TextLarge strong className={Classes.body}>
        {t('cars.sell.text')}
      </TextLarge>
      <form method="get" action="/plaats/91" className={`hz-Form ${Classes.Form}`}>
        {withLicensePlateField && (
          <LicensePlateTextField
            id="licensePlate"
            labelText={t('cars.sell.license_plate.label')}
            value={licensePlate}
            locale="nlnl"
            countryCode="NL"
            onChange={(e) => setLicensePlate(e.target.value)}
            ariaLabel={t('cars.sell.license_plate_label')}
          />
        )}
        <div className={Classes.actions}>
          {withLicensePlateField && (
            <SecondaryButton
              as="a"
              href={`/m/auto/auto-verkopen/?licensePlate=${licensePlate}`}
              onClick={() => {
                trackGAEvent('checkSellPriceClicked');
              }}
              className={Classes.action}
            >
              {t('cars.sell.check_price')}
            </SecondaryButton>
          )}
          <PrimaryButton
            type="submit"
            className={Classes.action}
            data-sem="placeAdAction"
            onClick={() => {
              trackGAEvent('placeAdButtonClicked', 'block');
            }}
          >
            {t('cars.sell.place_ad_button')}
          </PrimaryButton>
        </div>
      </form>
    </>
  );
};

export default SellBlock;
